var _g, _g2, _path, _path2, _path3, _path4, _g3, _g4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 245,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#lock_svg__filter0_ii_1976_1209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.756,
    y: 76.334,
    width: 146,
    height: 124,
    rx: 2,
    transform: "rotate(-15 89.756 76.334)",
    fill: "#F5F7FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#lock_svg__filter1_bd_1976_1209)",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.041,
    y: 77.305,
    width: 168,
    height: 114,
    rx: 2,
    transform: "rotate(-15 32.04 77.305)",
    fill: "#fff",
    fillOpacity: 0.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.265,
    y: 78.012,
    width: 166,
    height: 112,
    rx: 1,
    transform: "rotate(-15 33.265 78.012)",
    stroke: "#fff",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7FA",
    d: "M34.49 78.719l158.412-42.446 5.176 19.318L39.666 98.038z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222B40",
    d: "M45.307 84.315l10.502-2.814.596 2.221-10.503 2.815zM62.39 79.526l10.502-2.814.599 2.236-10.503 2.814z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F6F9",
    d: "M54.82 119.817l19.319-5.176 5.176 19.318-19.319 5.176z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7FA",
    d: "M90.559 110.24l19.319-5.175 5.176 19.318-19.319 5.176zM126.298 100.664l19.319-5.176 5.176 19.318-19.319 5.177zM63.102 150.727l19.319-5.176 5.176 19.318-19.319 5.176zM98.841 141.15l19.319-5.176 5.176 19.318-19.319 5.177z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#lock_svg__filter2_b_1976_1209)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.17,
    d: "M165.482 107.807l108.184-28.988 23.293 86.934-108.183 28.987z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3,
    d: "M167.319 108.868l105.286-28.211 22.517 84.035-105.286 28.212z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#lock_svg__filter3_dii_1976_1209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 91.281,
    width: 57,
    height: 57,
    rx: 28.5,
    transform: "rotate(-15 139 91.281)",
    fill: "url(#lock_svg__paint0_radial_1976_1209)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180 106.529h2a.997.997 0 011 1v12a1 1 0 01-1 1h-16a1.002 1.002 0 01-1-1v-12a.997.997 0 011-1h2v-1a6 6 0 1112 0v1zm-13 2v10h14v-10h-14zm5 4h4v2h-4v-2zm6-6v-1a3.998 3.998 0 00-4-4 3.999 3.999 0 00-4 4v1h8z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "lock_svg__filter0_ii_1976_1209",
    x: 84.205,
    y: 32.995,
    width: 182.221,
    height: 166.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.76105 0 0 0 0 0.79122 0 0 0 0 0.838807 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1976_1209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6,
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_1976_1209",
    result: "effect2_innerShadow_1976_1209"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lock_svg__filter1_bd_1976_1209",
    x: 8.489,
    y: 7.272,
    width: 270.883,
    height: 232.699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1976_1209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16,
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00784314 0 0 0 0 0.184314 0 0 0 0 0.411765 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_1976_1209",
    result: "effect2_dropShadow_1976_1209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1976_1209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lock_svg__filter2_b_1976_1209",
    x: 147.482,
    y: 60.819,
    width: 167.477,
    height: 151.921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1976_1209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1976_1209",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lock_svg__filter3_dii_1976_1209",
    x: 91.398,
    y: 28.927,
    width: 179.014,
    height: 179.014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.890226 0 0 0 0 0.267095 0 0 0 0 0.36016 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1976_1209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1976_1209",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.468975 0 0 0 0 0.0434092 0 0 0 0 0.107383 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_1976_1209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.961501 0 0 0 0 0.961501 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_innerShadow_1976_1209",
    result: "effect3_innerShadow_1976_1209"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lock_svg__paint0_radial_1976_1209",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.50292 70.82843 -68.38365 14.00232 164.127 112.53)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#E34C62"
  })))));
}
export default SvgLock;